module.exports = __webpack_public_path__ + "img/border_middle_brackets.8f38d588.svg";